import { createSlice } from "@reduxjs/toolkit";
//#region ../src/state/recording-slice.ts
const recordingSlice = createSlice({
	name: "recording",
	initialState: {
		isRecording: false,
		sessionMetadata: null,
		actionCount: 0,
		failedWriteCount: 0
	},
	reducers: {
		startSession(state, action) {
			state.isRecording = true;
			state.sessionMetadata = action.payload;
			state.actionCount = 0;
			state.failedWriteCount = 0;
		},
		endSession(state) {
			state.isRecording = false;
		},
		/**
		* Record a depth sample from WebXR depth sensing.
		* The sample includes camera pose and a grid of depth points.
		* This action is persisted to enable replay with depth data.
		*/
		recordDepthSample(_state, _action) {},
		/**
		* Record a write failure during persistence.
		* User Feedback Issue #1 Part B: Track write failures for session summary.
		*/
		recordWriteFailure(state, _action) {
			state.failedWriteCount += 1;
		}
	}
});
const { startSession, endSession, recordDepthSample, recordWriteFailure } = recordingSlice.actions;
const recordingReducer = recordingSlice.reducer;
//#endregion
export { endSession, recordDepthSample, recordWriteFailure, recordingReducer, startSession };
